<template>
  <div class="quotationCreationSuccess">
    <Header />
    <div uk-height-viewport>
      <div class="uk-flex-center uk-width-auto uk-position-center">
        <img height="350" width="200" src="../assets/email-sent.png" />
        <p class="uk-heading-large uk-text-uppercase uk-text-bold">MERCI !</p>
        <p
          class="uk-text-uppercase uk-text-bold"
        >Votre devis vous a été envoyé à l'adresse indiquée.</p>
        <p
          class="uk-text-uppercase uk-text-bold"
        >Pensez à vérifier vos spams.</p>
        <p
          v-show="isConnected && !isLoading && !hasError"
          class="uk-text-uppercase uk-text-bold"
        >Il sera aussi disponible d'ici quelques instants dans les documents de votre espace client.</p>
        <div
          v-show="isConnected && !isLoading && !hasError"
          class="uk-margin uk-grid-small uk-child-width-auto uk-flex uk-flex-center"
        >
          <!-- <router-link
            :to="{ path: `/check-quotation/${quotation.quotationID}` }"
            replace>
            <button
              class="uk-button uk-button-primary uk-margin-top uk-animation-scale-up uk-border-rounded uk-text-bold"
            >PAYER {{quotation.amount.toFixed(2)}} €</button>
          </router-link> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UIkit from "uikit";
import Invoice from "../models/invoice";
import firebase from "firebase";
import Header from "../components/Header";
import router from "../router";
import { log } from "util";

export default {
  name: "quotationCreationSuccess",
  components: {
    Header
  },
  mounted() {
    const self = this;
    self.isConnected = localStorage.currentUser != null;

    firebase
      .firestore()
      .collection("Quotations")
      .where("quotationID", "==", this.$route.params.quotationID)
      .get()
      .then(querySnapshot => {
        self.isLoading = false;
        self.hasError = false
        if (querySnapshot.docs.length != 1) {
          this.displayErrorMessage(
            "Aucun devis ne porte ce numéro d'identification."
          );
          return;
        }
        querySnapshot.forEach(doc => {
          self.quotation = doc.data();
        });
      })
      .catch(error => {
        self.isLoading = false;
        self.hasError = true
        this.displayErrorMessage(
          "Aucun devis ne porte ce numéro d'identification."
        );
      });

    if (!self.isConnected) {
      setTimeout(function() {
        window.location.href = "https://checkmy.house";
      }, 3500);
    }
  },

  data() {
    return {
      email: "",
      quotation: { amount: 0 },
      isConnected: false,
      isLoading: true,
      hasError: false
    };
  },

  methods: {
    // pay: function() {
    //   router.push({
    //     path: "/check-quotation",
    //     params: { quotationID: data.quotationID }
    //   });
    // }
  }
};
</script>
